import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { isObject } from "@next-core/utils/general";
export function convertDataSource(resource) {
  var name = resource.name,
    http = resource.http,
    api = resource.api,
    params = resource.params,
    tool = resource.tool,
    transform = resource.transform,
    rejectTransform = resource.rejectTransform,
    config = resource.config,
    scope = resource.scope,
    isRawProvider = resource.isRawProvider;
  var hasEnabled = config && Object.prototype.hasOwnProperty.call(config, "enabled");
  return _objectSpread(_objectSpread({
    name: name,
    resolve: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isRawProvider ? {
      useProvider: api,
      args: params
    } : http ? {
      useProvider: "basic.http-request",
      args: [api, params]
    } : tool ? {
      useProvider: "ai-portal.call-tool",
      args: [tool, params]
    } : _objectSpread({
      useProvider: "".concat(api, ":*"),
      params: params
    }, api === "easyops.api.data_exchange.olap@Query" && isObject(params) ? {
      params: _objectSpread(_objectSpread({}, params), {}, {
        translate: ["#showKey"],
        limit: undefined,
        limitBy: undefined,
        order: undefined,
        displayName: true
      })
    } : null)), transform ? {
      transform: {
        value: transform
      }
    } : null), rejectTransform ? {
      onReject: {
        transform: {
          value: rejectTransform
        }
      }
    } : null), hasEnabled ? {
      "if": config.enabled
    } : null),
    track: true
  }, hasEnabled ? {
    value: config.fallback
  } : null), scope === "template" ? {
    expose: false
  } : null);
}
//# sourceMappingURL=convertDataSource.js.map